<template>
    <div class="action-width">
        <v-btn text class="ma-0" color="blue" @click="$emit('edit')">
            <v-icon left>edit</v-icon>
            <span class="d-none d-lg-inline">Upravit</span>
        </v-btn>
        <v-btn text class="ma-0" color="error"
               @click="$emit('delete')" v-if="!hideDelete"
               :disabled="disableDelete"
        >
            <v-icon left color="red">delete_forever</v-icon>
            <span class="d-none d-lg-inline">Smazat</span>
        </v-btn>
    </div>
</template>
<script>
    export default {
        name: 'EditDeleteActions',

        props: {
            hideDelete: {
                type: Boolean,
                default: false
            },
            disableDelete: {
                type: Boolean,
                default: false
            }
        }
    }
</script>
<style lang="scss">
    .action-width {
        white-space: nowrap;
    }
</style>